import { useSearchParams } from 'react-router-dom'

/**
 * True when the webview URL carries `from=HOME` (native home embed).
 *
 * Used by ElitePlansTabbedPageLayout (`/elite-plans`, `/elite-plans-member`) and
 * ElitePrimeDashboardHeader (Elite/Prime locked landing + dashboard routes) to
 * skip the webview header and keep status-bar padding only.
 */
export function useElitePlansIsFromHome() {
  const [searchParams] = useSearchParams()
  return searchParams.get('from') === 'HOME'
}
